import { request } from '../../Common/api/client';

const DEFAULT_ENDPOINT = '/api/terminal/gasystem/customers';

export async function searchGasystemCustomers(params = {}, configuredEndpoint) {
  const endpoint = String(configuredEndpoint || '').trim();
  const url = endpoint.startsWith('/api/terminal/') ? endpoint : DEFAULT_ENDPOINT;
  const query = {
    page: params.page || 1,
    limit: params.limit || 100,
  };
  const q = String(params.q || '').trim();
  const businessNo = String(params.businessNo || '').replace(/\D/g, '');
  if (q) query.q = q;
  if (businessNo) query.businessNo = businessNo;
  return request({ method: 'GET', url, params: query });
}
